<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.3335 7.33334L8.00016 2.66668L12.6668 7.33334M8.00016 13.3333L8.00016 2.66668L8.00016 13.3333Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
